// @flow
import { handleActions, type ActionType } from 'redux-actions';
import AsyncValue, { type AsyncValueType } from 'lib/async-value';
import {
  fetchClients,
  storeClients,
  selectClient,
  showClientMenu,
  hideClientMenu,
} from './clientsActions';
import storage from './storage';

export type ClientRecord = {
  +clients: ?AsyncValueType<Array<MerchantGroupBlob>>,
  +currentClient: ?number,
  +showMenu: boolean,
};

const defaultState: ClientRecord = {
  clients: undefined,
  currentClient: undefined,
  showMenu: true,
  ...storage.getState(),
};

const clientsReducer = handleActions(
  {
    [selectClient.toString()]: (
      state: ClientRecord,
      action: ActionType<selectClient>
    ) => {
      return {
        ...state,
        currentClient: action.payload,
      };
    },

    [fetchClients.toString()]: (
      state: ClientRecord,
      action: ActionType<fetchClients>
    ) => {
      return {
        ...state,
        clients: AsyncValue.Pending,
      };
    },

    [storeClients.toString()]: {
      next(state: ClientRecord, action: ActionType<storeClients>) {
        return {
          ...state,
          clients: action.payload,
        };
      },
      throw(state: ClientRecord, action: ActionType<storeClients>) {
        return {
          ...state,
          clients: action.payload,
        };
      },
    },

    [showClientMenu.toString()]: (state: ClientRecord) => ({
      ...state,
      showMenu: true,
    }),
    [hideClientMenu.toString()]: (state: ClientRecord) => ({
      ...state,
      showMenu: false,
    }),
  },
  defaultState
);

export function determineNextClient(
  clients: Array<MerchantGroupBlob>,
  currentClient: ?number
): {
  clients: Array<MerchantGroupBlob>,
  currentClient: ?number,
} {
  let nextClient = currentClient;

  if (clients.length === 0) {
    nextClient = null;
  } else if (clients.length === 1) {
    nextClient = clients[0].merchant_group_id;
  } else if (nextClient != null) {
    const indexOfClient = clients.find(
      ({ merchant_group_id }) => merchant_group_id === nextClient
    );
    if (!indexOfClient) {
      nextClient = null;
    }
  }

  return {
    currentClient: typeof nextClient === 'string' ? +nextClient : nextClient,
    clients,
  };
}

export default clientsReducer;



// WEBPACK FOOTER //
// ./src/containers/client/clientsReducer.js